import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'small';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block"
      data-product-shop=""
    >
      <div className={`relative overflow-hidden rounded-lg bg-background-100 ${size === 'small' ? 'aspect-[3/4]' : 'aspect-[5/7]'}`}>
        <img
          src={comic.cover}
          alt={comic.title}
          title={`${comic.title} - 韩国漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <p className="text-white text-xs line-clamp-2">{comic.description}</p>
        </div>
        {comic.status === '连载中' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-white rounded-full">
            连载
          </span>
        )}
        {comic.status === '已完结' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-medium bg-foreground-600 text-white rounded-full">
            完结
          </span>
        )}
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-black/60 text-amber-400 text-[10px] px-1.5 py-0.5 rounded-full">
          <i className="ri-star-fill text-[10px]"></i>
          {comic.rating}
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className={`font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors ${size === 'small' ? 'text-xs' : 'text-sm'}`}>
          {comic.title}
        </h3>
        <p className={`text-foreground-500 mt-0.5 ${size === 'small' ? 'text-[10px]' : 'text-xs'}`}>
          {comic.author} · {comic.category}
        </p>
      </div>
    </Link>
  );
}